"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const theme_1 = require("../theme");
const input_style_1 = require("./input.style");
exports.CSS = {
    container: 'c-MultiListInput',
    label: 'c-MultiListInput__label',
    button: 'c-MultiListInput__button',
    edit: 'c-MultiListInput__edit',
    colorIndicator: 'c-MultiListInput__colorIndicator',
};
exports.Style = {
    [exports.CSS.container]: {
        display: 'flex',
        flex: 1,
        'align-items': 'center',
        'justify-content': 'space-between',
        [`& .${input_style_1.CSS.container}`]: {
            cursor: 'pointer',
        },
    },
    [exports.CSS.button]: {
        flex: 1,
        display: 'flex',
        'font-family': theme_1.DefaultTheme.font.familyCondensed,
        'font-size': theme_1.DefaultTheme.font.size,
        height: theme_1.DefaultTheme.space(5),
        'line-height': theme_1.DefaultTheme.space(5),
        'align-items': 'center',
        'justify-content': 'space-between',
        'text-align': 'left',
        padding: 0,
        color: 'inherit',
        'font-weight': 'normal',
        'text-transform': 'none',
    },
    [exports.CSS.label]: {
        overflow: 'hidden',
        flex: 1,
        'text-overflow': 'ellipsis',
    },
    [exports.CSS.edit]: {
        transform: 'rotate(-90deg)',
        'font-size': 'inherit',
        color: theme_1.DefaultTheme.font.color.divider,
    },
    [exports.CSS.colorIndicator]: {
        width: theme_1.DefaultTheme.space(3),
        height: theme_1.DefaultTheme.space(3),
        'border-radius': '50%',
        marginRight: theme_1.DefaultTheme.space(2),
    },
};
//# sourceMappingURL=nested.list.input.style.js.map